module.exports = __webpack_public_path__ + "static/media/tt_commons_bold-webfont.d2120697.woff2";